// tslint:disable:variable-name
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../../../../core";
import { SidebarComponent } from "@syncfusion/ej2-angular-navigations";
import {
  ButtonPropsModel,
  DialogComponent,
} from "@syncfusion/ej2-angular-popups";
import { CheckBoxComponent } from "@syncfusion/ej2-angular-buttons";
import { ContactService } from "../../../../../core/store/services/contact.service";
import {
  EventsSetStatusNull,
  EventUpdateAttendee,
} from "../../../../../core/store/actions/events.actions";

@Component({
  selector: "app-events-attendees-update-form",
  templateUrl: "./events-attendees-update.component.html",
  styleUrls: ["./events-attendees-update.component.scss"],
})
export class EventsAttendeesUpdateComponent
  implements OnInit, OnChanges, OnDestroy
{
  @ViewChild("sidebarInstance") public sidebarInstance: SidebarComponent;
  @ViewChild("clearModal") public clearModal: DialogComponent;
  @ViewChild("checkbox") public checkbox: CheckBoxComponent;
  @ViewChild("checkbox1") public checkbox1: CheckBoxComponent;
  // Listeners
  @Input() selectedEventCode: string;
  @Input() selectedContactList: any;
  @Output() valueChange = new EventEmitter();
  // style props
  public width = "auto";
  public position = "Right";
  // Field Props
  public contactFields: object = { value: "value", text: "name" };
  public invite_status_options: any[] = [];
  public invite_status_fields: object = {
    value: "status_code",
    text: "status_name",
  };
  eventAttendeeForm: FormGroup;
  // Form Props
  public formSent: boolean;
  error$: Observable<any>;
  success$: Observable<any>;
  public dltButtons: ButtonPropsModel[] = [
    {
      click: this.clearAll.bind(this),
      buttonModel: { content: "Yes", isPrimary: true },
    },
    {
      click: this.hideClearAllModal.bind(this),
      buttonModel: { content: "Cancel", isPrimary: false },
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
    private cd: ChangeDetectorRef,
    private contactService: ContactService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedContactList) {
      if (this.selectedContactList && this.selectedContactList.length > 0) {
        setTimeout(() => {
          try {
            // Check if all selected items have the same values
            const firstItem = this.selectedContactList[0];
            
            // Check if all have the same has_attended_yn value
            const allSameAttended = this.selectedContactList.every(
              (item) => item.has_attended_yn === firstItem.has_attended_yn
            );
            
            // Check if all have the same is_confirmed_yn value
            const allSameConfirmed = this.selectedContactList.every(
              (item) => item.is_confirmed_yn === firstItem.is_confirmed_yn
            );
            
            // Check if all have the same comment
            const allSameComment = this.selectedContactList.every(
              (item) => item.comment === firstItem.comment
            );
            
            // Check if all have the same invite_status_code
            const getInviteCode = (item) => 
              item.invite_status_code || (item.contact && item.contact.invite_status_code);
            const firstInviteCode = getInviteCode(firstItem);
            const allSameInviteStatus = this.selectedContactList.every(
              (item) => getInviteCode(item) === firstInviteCode
            );

            this.eventAttendeeForm.patchValue({
              comment: allSameComment ? firstItem.comment : "",
              has_attended: allSameAttended ? firstItem.has_attended_yn === 1 : false,
              is_confirmed: allSameConfirmed ? firstItem.is_confirmed_yn === 1 : false,
              invite_status: allSameInviteStatus ? firstInviteCode : "",
            });
            this.cd.detectChanges();
          } catch (e) {}
        }, 1000);
      }
    }
  }

  ngOnInit(): void {
    this.generateArticleContactForm();
    this.getInviteStatuses();
    this.error$ = this.store.pipe(
      select((store) => {
        if (!store || !store.events || !store.events.error) {
          return;
        }
        return store.events.error;
      }),
    );
    this.error$.subscribe((data: any) => {
      if (data) {
        this.formSent = false;
      }
    });
    this.success$ = this.store.pipe(
      select((store) => {
        if (!store || !store.events || !store.events.success) {
          return;
        }
        return store.events.success.isForm;
      }),
    );
    this.success$.subscribe((data: any) => {
      if (data) {
        this.formSent = false;
        this.closeSidebar();
        // this.store.dispatch(new EventsSetStatusNull());
      }
    });
  }

  generateArticleContactForm() {
    this.eventAttendeeForm = this.formBuilder.group({
      comment: new FormControl("", [Validators.maxLength(1000)]),
      has_attended: new FormControl(false),
      is_confirmed: new FormControl(false),
      invite_status: new FormControl(""),
    });
  }

  getInviteStatuses() {
    this.contactService.getInviteStatuses().subscribe((response: any) => {
      this.invite_status_options = response?.data;
      this.cd.detectChanges();
    });
  }

  openSidebar(): void {
    this.sidebarInstance.show();
  }

  public closeSidebar(): void {
    this.sidebarInstance.hide();
    this.selectedContactList = [];
    if (this.eventAttendeeForm) {
      this.eventAttendeeForm.reset();
    }
    this.valueChange.emit("close");
  }
  clearAll() {
    this.formSent = false;
    this.clearModal.hide();
    if (this.eventAttendeeForm) {
      this.eventAttendeeForm.reset();
    }
  }

  hideClearAllModal() {
    this.clearModal.hide();
  }
  clear() {
    this.clearModal.show();
  }
  // Submit form
  updateEventAttendees(form: FormGroup) {
    if (!form.invalid) {
      const postData = {
        event_code: this.selectedEventCode,
        company_contact_code: [],
      };
      try {
        if (this.selectedContactList && this.selectedContactList.length > 0) {
          postData.company_contact_code = this.selectedContactList.map((el) => {
            return {
              code: el.company_contact_code,
              comment: form.value.comment,
              has_attended_yn: form.value.has_attended ? 1 : 0,
              invite_status_code: form.value.invite_status,
              is_confirmed_yn: form.value.is_confirmed ? 1 : 0,
            };
          });
        }
      } catch {}
      console.log(postData);
      this.store.dispatch(new EventUpdateAttendee(postData));
      this.formSent = true;
    }
  }
  ngOnDestroy() {}
}
